/**
 * Calls `preventDefault()` on the passed event-like object.
 * @param e Event-like object.
 */
export const preventDefault = function preventDefault(e: {
  preventDefault: () => void;
}) {
  e.preventDefault();
};
